import BillingStore from "./billing.store";
import UIStore from "./ui.store";
import ProfileStore from "./profile.store";
import QuizObjectsStore from "./quiz_object.store";
import QuizzerStore from "./quizzer.store";
import SubjectsStore from "./subject.store";
import QuestionListStore from "./question_list.store";
import DebugStore from "./debug.store";
import ReferenceStore from "./reference.store"

export default class RootStore {
    debugStore: DebugStore;
    subjectStore: SubjectsStore;
    uiStore: UIStore;
    profileStore: ProfileStore;
    objectStore: QuizObjectsStore;
    quizzerStore: QuizzerStore;
    questionListStore: QuestionListStore;
    billingStore: BillingStore
    referenceStore: ReferenceStore;
    localStorage: any
    constructor(localStorage: any) {
        this.localStorage = localStorage;
        
        this.debugStore = new DebugStore(this);
        this.billingStore  = new BillingStore(this);
        this.subjectStore = new SubjectsStore(this);
        this.uiStore       = new UIStore(this);
        this.profileStore  = new ProfileStore(this);
        this.objectStore  = new QuizObjectsStore(this);
        this.quizzerStore  = new QuizzerStore(this);
        this.questionListStore = new QuestionListStore(this);
        this.referenceStore = new ReferenceStore(this);

        if (process.env.NODE_ENV !== 'test') {
            this.profileStore.fetchProfile();
            this.uiStore.init();
        }
    }
}
